export const SUPPORTED_CARRIERS = [
  { id: "Cover Whale", label: "Cover Whale", sub: "Instant Quote", active: true },
  { id: "Nirvana", label: "Nirvana", sub: "1-2 Business Days", active: true },
  { id: "Accelerant", label: "Accelerant", sub: "1-2 Business Days", active: true },
  { id: "Progressive", label: "Progressive", sub: "1-2 Business Days", active: true },
  { id: "Corgi Trucking", label: "Corgi Trucking", sub: "1-2 Business Days", active: true },
];

export const SUPPORTED_CARRIER_IDS = SUPPORTED_CARRIERS.map((carrier) => carrier.id);

export const ACTIVE_SUPPORTED_CARRIERS = SUPPORTED_CARRIERS.filter(
  (carrier) => carrier.active,
);

export const ACTIVE_SUPPORTED_CARRIER_IDS = ACTIVE_SUPPORTED_CARRIERS.map(
  (carrier) => carrier.id,
);
